var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllusUpgradeSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M146.412 118.509C143.175 115.585 140.238 113.226 138.178 112.023C129.917 107.208 120.221 106.954 114.729 107.604C113.878 107.708 113.131 107.825 112.507 107.955C112 108.059 111.577 108.169 111.246 108.267C107.821 109.339 105.884 102.528 110.758 99.9742C115.633 97.4266 119.292 97.3681 119.474 95.9773C119.519 95.6654 119.051 95.1065 118.278 94.3591C115.665 91.857 109.764 87.0932 106.775 82.1475C102.895 75.733 104.727 72.9319 106.476 72.295C106.918 72.1391 107.34 71.9896 107.782 71.9376H107.795C109.121 71.8076 110.654 72.581 113.404 76.6624C115.1 79.171 117.004 81.2311 118.661 82.7909C115.087 77.2993 111.077 67.3038 113.501 64.1843C113.956 63.5994 114.45 63.203 114.944 63.0015C116.146 62.4946 117.374 63.086 118.161 64.7172C118.98 66.4265 121.248 71.3527 123.704 75.486C123.672 75.4211 123.639 75.3496 123.613 75.2716C122.067 71.6581 121.677 64.3468 123.815 62.982C124.484 62.5531 125.03 62.3776 125.498 62.4361C126.746 62.5921 127.448 64.4833 128.527 68.0447C130.249 73.7053 132.705 78.755 132.705 78.755V78.742C132.712 78.6641 132.738 77.8842 132.777 75.3561C132.842 70.9108 131.991 68.2007 133.368 66.056C134.005 65.0682 135.032 64.8277 135.974 65.2437C136.748 65.5881 137.125 66.303 137.365 67.3623C140.465 80.9647 143.559 86.4498 148.394 91.1031C151.975 94.5541 159.956 100.67 167.599 105.94C168.71 91.584 168.372 80.9972 167.066 69.208C164.538 46.3771 150.896 36.7911 129.651 34.0226C112.845 31.8259 88.7594 30.6626 64.4532 34.172C39.4971 37.7725 34.6294 53.188 32.9266 72.6135C31.2239 92.0455 31.4839 98.9344 32.9266 114.98C35.2598 140.781 44.8978 148.093 69.7304 149.522C93.1137 150.868 110.063 150.803 130.411 149.522C133.219 149.347 135.903 148.938 138.451 148.32C136.559 145.103 135.474 141.353 135.474 137.363C135.461 129.304 139.874 122.259 146.412 118.509Z",
    fill: "url(#paint0_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M137.365 67.3688C137.125 66.303 136.748 65.5881 135.975 65.2501C135.039 64.8407 134.005 65.0747 133.368 66.0625C131.991 68.2072 132.842 70.9172 132.777 75.3625C132.738 77.8906 132.712 78.664 132.706 78.7485V78.7615C132.706 78.7615 130.249 73.7118 128.527 68.0512C127.454 64.4962 126.752 62.5985 125.498 62.4426C125.03 62.3841 124.484 62.5595 123.815 62.9885C121.677 64.3533 122.067 71.6646 123.613 75.2781C123.639 75.356 123.672 75.4275 123.704 75.4925C121.248 71.3592 118.98 66.4329 118.161 64.7237C117.381 63.099 116.146 62.5076 114.944 63.008C114.45 63.2095 113.949 63.6059 113.501 64.1908C111.077 67.3103 115.087 77.3057 118.661 82.7974C117.004 81.2376 115.093 79.1774 113.404 76.6688C110.654 72.5875 109.121 71.8141 107.795 71.9441H107.782C107.34 71.9961 106.918 72.1455 106.476 72.3015C104.727 72.9384 102.895 75.7395 106.775 82.154C109.764 87.0997 115.665 91.8635 118.278 94.3656C119.058 95.1064 119.519 95.6654 119.474 95.9838C119.292 97.3746 115.633 97.4331 110.758 99.9807C105.884 102.535 107.821 109.346 111.246 108.273C111.577 108.169 112 108.059 112.507 107.961C113.131 107.831 113.878 107.714 114.729 107.61C120.221 106.961 129.917 107.214 138.178 112.03C140.238 113.232 143.175 115.591 146.412 118.516C149.59 116.69 153.275 115.643 157.194 115.643C160.43 115.643 163.504 116.358 166.266 117.638C166.578 116.001 166.832 114.311 167.007 112.556C167.235 110.269 167.43 108.072 167.592 105.966C159.949 100.696 151.969 94.58 148.388 91.1291C143.559 86.4563 140.459 80.9712 137.365 67.3688Z",
    fill: "url(#paint1_linear_2455_8406)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M105.741 38.3833C106.781 38.3833 106.781 36.7585 105.741 36.7585C104.701 36.7585 104.701 38.3833 105.741 38.3833Z",
    fill: "url(#paint2_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "status"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M139.991 137.363C139.991 146.845 147.699 154.566 157.194 154.566C166.676 154.566 174.396 146.845 174.396 137.363C174.396 127.874 166.676 120.16 157.194 120.16C147.705 120.16 139.991 127.881 139.991 137.363Z",
    fill: "url(#paint3_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.091 130.682C167.28 131.598 167.501 133.301 166.591 134.49L157.584 146.208L157.558 146.24C156.524 147.508 154.568 147.742 153.275 146.539C153.275 146.539 153.275 146.539 153.268 146.533L148.095 141.737C146.997 140.716 146.932 139 147.946 137.896C148.966 136.797 150.682 136.732 151.787 137.753L154.965 140.69L162.276 131.176C163.192 129.993 164.901 129.765 166.091 130.682Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M83.4432 95.5681L70.6402 79.4441C70.6402 79.4441 46.5939 80.9324 32.1077 83.298C31.4253 94.5022 31.7308 101.326 32.7056 112.517C48.8621 108.657 83.4367 95.5746 83.4432 95.5681Z",
    fill: "#FFECDA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.4302 95.5744L70.6272 79.4504C70.6272 79.4504 46.8019 80.8737 32.2247 83.2913L32.0037 91.688C32.1467 91.6685 32.2897 91.6425 32.4262 91.623C41.7782 90.2777 58.968 90.9016 69.2754 100.748C77.2236 97.9465 83.4367 95.5744 83.4302 95.5744Z",
    fill: "url(#paint4_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M78.6664 96.5038C70.9456 96.8743 67.8261 92.5265 64.4076 87.8212C61.1711 83.3564 58.643 82.3296 55.1271 79.691C51.3252 76.8379 53.7688 72.1976 58.6365 73.5819C61.3206 74.3488 64.0762 75.7461 66.6693 77.4618C69.4898 79.3335 69.3469 77.3188 68.4565 73.6989C67.3777 69.2666 65.311 64.3859 61.8665 56.9315C59.0655 50.881 66.3183 48.5154 69.6328 54.7024C72.3299 59.7326 73.3502 62.9431 74.7735 67.1739C75.04 61.0519 74.0261 53.9355 72.4989 48.9183C70.9781 43.9011 76.5932 42.7118 79.2448 46.4487C81.305 49.3667 83.0077 60.194 83.0272 64.0869C85.0549 60.4215 86.9526 54.7804 88.0899 50.1336C89.0648 46.1562 94.4719 46.8321 94.212 52.9022C93.952 58.9787 90.2606 67.5639 90.1956 68.6492C90.1371 69.7345 90.6635 69.5851 92.8472 66.94C94.7579 64.6328 99.1317 58.1858 102.609 60.337C105.501 62.1242 97.5589 71.1318 95.9082 75.9865C94.3354 80.6268 95.1478 89.212 89.8966 92.8254C85.3668 95.9514 80.902 96.3804 78.6469 96.4843L78.6664 96.5038Z",
    fill: "#FFECDA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M82.1239 93.7351C86.2312 83.1028 78.335 74.6086 70.9456 78.638L82.1239 93.7351Z",
    fill: "url(#paint5_linear_2455_8406)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M112.78 135.556C114.794 134.542 113.521 130.669 109.699 130.305V130.298C105.715 129.915 102.7 133.112 99.9572 132.066C97.2146 131.02 99.8337 125.229 100.542 117.599C101.14 111.23 100.659 106.031 98.3714 104.939C96.4087 104.003 95.2584 106.155 94.9789 110.113C94.407 118.217 93.0358 122.09 93.0358 122.09C93.0358 122.09 93.2957 115.721 92.3794 107.799C92.1649 105.992 91.3785 102.041 88.233 102.041C85.159 102.047 86.2898 106.103 86.1598 111.451C85.9389 120.563 85.198 123.416 85.198 123.416C85.185 119.718 84.6456 112.498 83.1118 108.527C82.1175 105.96 79.6998 105.024 78.1856 105.719C77.1262 106.207 76.5153 107.493 77.2757 112.017C77.9321 115.923 78.3351 119.504 78.1531 123.357C77.5942 121.954 76.7818 120.615 75.8199 118.932C73.8962 115.565 71.2317 114.025 69.6329 116.3C68.5021 117.911 71.1667 120.784 72.9474 126.334C75.6185 134.653 75.1701 142.724 73.5843 149.724C82.3514 150.185 90.2412 150.432 97.819 150.484C101.374 140.736 107.054 138.442 112.78 135.556Z",
    fill: "url(#paint6_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M100.776 112.283C100.776 112.283 100.678 110.847 99.4372 109.32C98.1958 107.792 96.4996 107.565 95.1088 108.923L95.1543 108.572C95.6027 105.622 96.6881 104.14 98.3778 104.946C99.9831 105.713 100.698 108.494 100.776 112.283Z",
    fill: "url(#paint7_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M92.4442 108.345C92.0738 105.843 89.6237 105.121 88.7333 105.108C87.7975 105.089 86.5172 105.693 86.0947 107.11C85.9972 104.056 86.0817 102.054 88.2394 102.047C91.3784 102.047 92.1713 105.999 92.3792 107.805C92.4052 107.987 92.4247 108.169 92.4442 108.345Z",
    fill: "url(#paint8_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M83.8137 110.808C82.4229 109.151 80.2067 108.631 78.5755 108.754C77.5551 108.832 76.9832 109.424 77.0807 110.619C76.6648 107.227 77.2497 106.161 78.1985 105.732C79.7063 105.037 82.1239 105.979 83.1183 108.54C83.3782 109.216 83.6122 109.982 83.8137 110.808Z",
    fill: "url(#paint9_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M75.105 117.807C74.5071 117.014 72.7524 116.793 71.5761 117.32C70.5622 117.781 70.0488 119.25 70.1853 119.815C69.4509 118.223 69.0739 117.118 69.6394 116.312C71.0496 114.311 73.2723 115.266 75.105 117.807Z",
    fill: "url(#paint10_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M112.786 135.556C112.578 135.66 112.377 135.764 112.169 135.868C112.162 134.666 110.947 133.32 108.516 132.956C105.449 132.495 103.142 133.463 100.62 132.241C103.187 132.638 106.034 129.947 109.706 130.305C113.52 130.675 114.794 134.542 112.786 135.556Z",
    fill: "url(#paint11_linear_2455_8406)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M137.365 67.3688C137.125 66.303 136.748 65.5881 135.974 65.2501C135.038 64.8407 134.005 65.0747 133.368 66.0625C131.99 68.2072 132.842 70.9172 132.777 75.3625C132.738 77.8906 132.712 78.664 132.705 78.7485V78.7615C132.705 78.7615 130.249 73.7118 128.527 68.0512C127.454 64.4962 126.752 62.5985 125.498 62.4426C125.03 62.3841 124.484 62.5595 123.815 62.9885C121.677 64.3533 122.067 71.6646 123.613 75.2781C123.639 75.356 123.672 75.4275 123.704 75.4925C121.248 71.3592 118.98 66.4329 118.161 64.7237C117.381 63.099 116.146 62.5076 114.944 63.008C114.45 63.2095 113.949 63.6059 113.501 64.1908C111.077 67.3103 115.087 77.3057 118.661 82.7974C117.004 81.2376 115.093 79.1774 113.403 76.6688C110.654 72.5875 109.121 71.8141 107.795 71.9441H107.782C107.34 71.9961 106.917 72.1455 106.475 72.3015C104.727 72.9384 102.895 75.7395 106.774 82.154C109.764 87.0997 115.665 91.8635 118.278 94.3656C119.057 95.1064 119.519 95.6654 119.473 95.9838C119.291 97.3746 115.633 97.4331 110.758 99.9807C105.884 102.535 107.821 109.346 111.246 108.273C111.577 108.169 112 108.059 112.507 107.961C113.13 107.831 113.878 107.714 114.729 107.61C120.221 106.961 129.917 107.214 138.177 112.03C140.238 113.232 143.175 115.591 146.412 118.516C149.59 116.69 153.275 115.643 157.194 115.643C160.43 115.643 163.504 116.358 166.266 117.638C166.578 116.001 166.831 114.311 167.007 112.556C167.234 110.269 167.429 108.072 167.592 105.966C159.949 100.696 151.968 94.58 148.387 91.1291C143.559 86.4563 140.459 80.9712 137.365 67.3688Z",
    fill: "url(#paint12_linear_2455_8406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.544 80.1587C126.148 79.0344 121.131 64.7172 125.154 62.4685C124.484 62.5725 124.153 62.683 123.49 63.1119C121.352 64.4767 121.742 71.7815 123.288 75.4015L123.392 75.6354C123.392 75.6354 123.418 75.6679 123.444 75.7199C123.529 75.8759 123.711 76.2074 123.964 76.6233C123.971 76.6233 123.984 76.6363 123.984 76.6428C124.029 76.7208 124.075 76.7988 124.127 76.8832C124.796 77.9816 125.791 79.5153 126.564 80.2237C126.564 80.2237 126.564 80.2042 126.544 80.1587ZM121.43 85.6504C121.536 85.8698 121.623 86.0464 121.687 86.1767C121.759 86.3243 121.803 86.4126 121.813 86.4368L118.349 83.0508L118.336 83.0313C114.762 77.5397 110.752 67.5443 113.176 64.4248C113.631 63.8398 114.125 63.4499 114.619 63.2419C111.85 65.2046 119.59 81.8095 121.43 85.6504ZM115.844 92.2042C112.838 89.607 108.705 86.0358 106.437 82.2774C102.563 75.8629 104.389 73.0553 106.138 72.4249L106.211 72.3989C106.627 72.2519 107.027 72.1104 107.444 72.0675H107.457H107.483C102.718 75.7199 109.647 85.8583 118.271 94.359C117.64 93.7559 116.799 93.029 115.844 92.2042ZM135.663 65.4644C133.043 66.1858 133.375 80.7305 133.375 80.7305L132.374 78.8783V78.8653C132.381 78.7809 132.407 78.0075 132.446 75.4794C132.464 74.0781 132.392 72.85 132.328 71.7581C132.19 69.381 132.088 67.6489 133.037 66.1793C133.674 65.198 134.798 64.886 135.663 65.4644ZM112.169 108.085C108.77 106.33 109.628 102.242 114.157 100.533C114.95 100.236 115.679 99.9857 116.333 99.7614C119.422 98.702 120.845 98.2139 119.467 95.9773C119.368 96.7318 118.149 97.1325 116.275 97.7479C114.695 98.2669 112.65 98.9387 110.42 100.104C105.546 102.658 107.483 109.469 110.908 108.397C111.239 108.293 111.668 108.189 112.169 108.085Z",
    fill: "url(#paint13_linear_2455_8406)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Confetti"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M96.0883 43.9964C97.7621 43.9964 99.1136 42.6325 99.1136 40.9525C99.1136 39.2725 97.7559 37.9087 96.0883 37.9087C94.4146 37.9087 93.0631 39.2725 93.0631 40.9525C93.0631 42.6325 94.4146 43.9964 96.0883 43.9964Z",
    fill: "#F4C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M143.849 50.6854C145.889 45.0502 152.764 40.9401 159.694 40.2644L163.079 44.2815C154.394 45.1184 149.174 49.0921 146.571 54.8017L143.849 50.6854Z",
    fill: "#FFC261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M154.064 59.6431C155.738 59.6431 157.089 58.2792 157.089 56.5993C157.089 54.9193 155.731 53.5554 154.064 53.5554C152.39 53.5554 151.032 54.9193 151.032 56.5993C151.032 58.2792 152.39 59.6431 154.064 59.6431Z",
    fill: "#C0CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M146.178 20.9539C146.426 26.1798 143.054 34.307 139.055 37.791L141.337 42.7442C141.337 42.7442 150.326 35.8631 151.032 23.291L146.178 20.9539Z",
    fill: "#F4C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M111.884 42.0374C99.8574 36.8425 107.482 21.053 96.4354 14.4198L100.93 10.415C111.909 19.2614 105.108 31.8583 115.814 37.5492L111.884 42.0374Z",
    fill: "#C0CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M128.163 40.1405C130.507 37.3757 131.542 31.0648 128.362 27.1965L122.485 26.7563C124.779 30.5069 124.754 37.1525 122.572 40.2645L128.163 40.1405Z",
    fill: "#9DF9DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M114.971 55.031C116.645 55.031 117.997 53.6672 117.997 51.9872C117.997 50.3072 116.639 48.9434 114.971 48.9434C113.297 48.9434 111.946 50.3072 111.946 51.9872C111.946 53.6672 113.304 55.031 114.971 55.031Z",
    fill: "#9DF9DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M131.505 52.2537C133.178 52.2537 134.53 50.8898 134.53 49.2099C134.53 47.5299 133.172 46.166 131.505 46.166C129.831 46.166 128.479 47.5299 128.479 49.2099C128.473 50.896 129.831 52.2537 131.505 52.2537Z",
    fill: "#FFC261"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2455_8406",
    x1: 124.989,
    y1: 31.9409,
    x2: 38.1998,
    y2: 157.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2455_8406",
    x1: 178.993,
    y1: 56.5924,
    x2: 61.4781,
    y2: 159.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1466DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2455_8406",
    x1: 104.959,
    y1: 37.5707,
    x2: 106.524,
    y2: 37.5707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A74EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2B75EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#398CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#429AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#459FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2455_8406",
    x1: 157.194,
    y1: 164.491,
    x2: 161.159,
    y2: 120.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11888F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2455_8406",
    x1: 42.6875,
    y1: 77.7753,
    x2: 90.3656,
    y2: 120.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FCE6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F5D8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E9BFAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E0AC98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2455_8406",
    x1: 76.637,
    y1: 86.1153,
    x2: 85.3554,
    y2: 79.9191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6CFB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2455_8406",
    x1: 83.4074,
    y1: 118.556,
    x2: 69.6314,
    y2: 232.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D68C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2455_8406",
    x1: 98.4372,
    y1: 108.914,
    x2: 100.206,
    y2: 105.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CEAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F8D3B6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FADCC1",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FCE3CA",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDE9D1",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FEEDD6",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEF0D9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1DB",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2455_8406",
    x1: 89.1274,
    y1: 104.796,
    x2: 88.9623,
    y2: 101.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CEAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F8D3B6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FADCC1",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FCE3CA",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDE9D1",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FEEDD6",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEF0D9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1DB",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2455_8406",
    x1: 80.3827,
    y1: 108.575,
    x2: 80.3827,
    y2: 105.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CEAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F8D3B6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FADCC1",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FCE3CA",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDE9D1",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FEEDD6",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEF0D9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1DB",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2455_8406",
    x1: 72.2338,
    y1: 117.609,
    x2: 71.7958,
    y2: 114.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CEAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F8D3B6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FADCC1",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FCE3CA",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDE9D1",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FEEDD6",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FEF0D9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1DB",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2455_8406",
    x1: 107.207,
    y1: 132.984,
    x2: 107.871,
    y2: 129.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CEAF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F8D2B5",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FDE5CE",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFEDD9",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2455_8406",
    x1: 109.3,
    y1: 74.33,
    x2: 197.17,
    y2: 142.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#FCE6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E0AC98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2455_8406",
    x1: 104.142,
    y1: 72.6915,
    x2: 142.389,
    y2: 84.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusUpgradeSuccess);
export default __webpack_public_path__ + "static/media/illus_upgrade_success.f0ccd7c8540d82c68c045b6155208212.svg";
export { ForwardRef as ReactComponent };